import * as React from 'react'
import { Text } from '@doordash/design-language'
import BulletListCell from '../components/BulletListCell'

import t from './strings'

const AdditionalInfoSection = ({ isNeverDelivered }) => (
  <React.Fragment>
    <Text styles={Text.Styles.PageTitle}>{t.additionalInfoTitleText()}</Text>
    {isNeverDelivered ? (
      <BulletListCell text={t.neverDeliveredAdditionalInfo1()} />
    ) : (
      <BulletListCell text={t.extremelyLateAdditionalInfo1()} />
    )}

    <BulletListCell text={t.policyAdditionalInfo()} />
    {isNeverDelivered ? (
      ''
    ) : (
      <BulletListCell text={t.extremelyLateAdditionalInfo2()} />
    )}
  </React.Fragment>
)

export default AdditionalInfoSection
